var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSquareArrowDown = function SvgSquareArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#square-arrow-down_svg__square-arrow-down_svg__clip0_2884_86277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.666 1.333a2 2 0 012 2v9.334a2 2 0 01-2 2H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2h9.333zM8 4.667a.667.667 0 00-.667.666v3.724L5.804 7.529l-.062-.056a.667.667 0 00-.88.998l2.666 2.667.063.055.061.043.066.035.073.029.075.02.084.011.05.002.078-.004.099-.02.07-.023.075-.036.074-.047a.63.63 0 00.075-.065l2.667-2.667.055-.062a.667.667 0 00-.055-.88l-.063-.056a.667.667 0 00-.88.056L8.666 9.057V5.333l-.004-.078A.667.667 0 008 4.667z",
    fill: "#91A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "square-arrow-down_svg__square-arrow-down_svg__clip0_2884_86277"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSquareArrowDown;